import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCorriere, getDatiAzienda } from '../services/api';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import '../print.css'; // Importa il CSS di stampa

function CorrieriPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [corriere, setCorriere] = useState(null);
  const [datiAzienda, setDatiAzienda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCorriereAndAziendaData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [corriereResponse, aziendaResponse] = await Promise.all([
          getCorriere(id),
          getDatiAzienda()
        ]);
        setCorriere(corriereResponse.data);
        setDatiAzienda(aziendaResponse.data);
      } catch (err) {
        setError('Errore nel caricamento dei dati per la stampa.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCorriereAndAziendaData();
  }, [id]);

  useEffect(() => {
    const handleAfterPrint = () => {
      // Introduce a small delay to ensure the print dialog is fully dismissed
      setTimeout(() => {
        navigate('/corrieri');
      }, 100);
    };

    if (!loading && !error && corriere && datiAzienda) {
      window.addEventListener('afterprint', handleAfterPrint);
      window.print();
    }

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [loading, error, corriere, datiAzienda, navigate]);

  const renderField = (label, value) => (
    <Row className="mb-2">
      <Col xs={5}><span className="label">{label}:</span></Col>
      <Col xs={7}><span className="value">{value || 'N/A'}</span></Col>
    </Row>
  );

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Preparazione stampa corriere...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <p>Impossibile preparare la stampa.</p>
      </Container>
    );
  }

  if (!corriere || !datiAzienda) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Dati del corriere o dell'azienda non trovati per la stampa.</Alert>
      </Container>
    );
  }

  return (
    <div id="printable-area" className="portrait-page">
      <div className="print-container">
        <header className="print-header">
          <div className="company-details">
            {datiAzienda.logo_url && (
              <img
                src={`${process.env.REACT_APP_STATIC_FILES_BASE_URL}${datiAzienda.logo_url}`}
                alt="Logo Azienda"
                style={{ maxHeight: '150px', maxWidth: '150px', marginRight: '20px', objectFit: 'contain' }}
              />
            )}
          </div>
          <div className="print-info">
            <p><strong>Data di Stampa:</strong> {new Date().toLocaleDateString()}</p>
            <p><strong>ID Corriere:</strong> {corriere.id}</p>
          </div>
        </header>

        <main>
          <h2 className="document-title">Scheda Corriere</h2>

          <section className="print-section">
            <div className="print-section-title">Dati Principali</div>
            <div className="print-section-content">
              <Row>
                <Col md={6}>
                  {renderField('Denominazione', corriere.denominazione)}
                  {renderField('Referente', corriere.referente)}
                </Col>
                <Col md={6}>
                  {renderField('Telefono', corriere.telefono)}
                  {renderField('Cellulare', corriere.cellulare)}
                </Col>
              </Row>
            </div>
          </section>

          <section className="print-section">
            <div className="print-section-title">Dati Spedizione</div>
            <div className="print-section-content">
              <Row>
                <Col md={6}>
                  {renderField('Tipo Spedizione', corriere.tipo_spedizione)}
                </Col>
                <Col md={6}>
                  {renderField('Costo reale spedizione (netto)', corriere.costo_netto_effettivo ? `€ ${Number(corriere.costo_netto_effettivo).toFixed(2)}` : 'N/A')}
                </Col>
              </Row>
            </div>
          </section>
        </main>

        <footer className="print-footer">
          <p>{datiAzienda.denominazione} - {datiAzienda.indirizzo} - {datiAzienda.cap} {datiAzienda.citta} ({datiAzienda.provincia}) - P.IVA {datiAzienda.piva}</p>
          <p>Email: {datiAzienda.email} - Tel: {datiAzienda.tel}</p>
        </footer>
      </div>
    </div>
  );
}

export default CorrieriPrint;